<template>
  <div class="body">
    <MomentItemFeedV2 :listType="listType" :refId="refId" v-if="refId && listType"></MomentItemFeedV2>
  </div>
</template>

<script>
  import MomentItemFeedV2 from "../../ugc_item/MomentItemFeedV2";

  export default {
    name: "MomentFeedUser",
    components: {
      MomentItemFeedV2,
    },
    props: {
      refId: {},
    },
    data() {
      return {
        listType: "moment_mine",
      }
    },

    mounted() {
    },
    methods: {
    },
  };
</script>

<style lang="scss" scoped>
  .body {
  }
</style>
